"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorialCarouselSectionSkeleton = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _react = require("react");
var _styles = require("../EditorialCarouselSection/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialCarouselSectionSkeleton = (param)=>{
    let { animation, count = _constants.NUMBER_OF_ARTICLES, className, shouldDisplayButton = false } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const articles = (0, _react.useMemo)(()=>(0, _lodash.default)(count).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ArticleBoxSkeleton, {
                animation: animation
            }, "".concat(_presentationComponents.ARTICLE_BOX_SKELETON, "-").concat(index))), [
        animation,
        count
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.EDITORIAL_CAROUSEL_SECTION_SKELETON),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Title, {
                        animation: animation
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.CarouselSkeleton, {
                        children: articles
                    })
                ]
            }),
            shouldDisplayButton ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.ButtonSkeleton, {
                "data-testid": getTestId(_constants.EDITORIAL_CAROUSEL_SECTION_BUTTON_SKELETON),
                variant: "rectangular",
                animation: animation
            }) : null
        ]
    });
};
exports.EditorialCarouselSectionSkeleton = EditorialCarouselSectionSkeleton;
